<template>
  <a-drawer
    :visible="visible"
    placement="right"
    :width="520"
    :mask="false"
    :destroy-on-close="true"
    :get-container="false"
    :closable="false"
    wrap-class-name="qv-drawer"
    @close="handleClose"
  >
    <div class="qv-modal" :class="{ 'qv-nav-active': hasNavigation }">
      <div class="qv-corner-actions">
        <template v-if="hasNavigation">
          <a-tooltip title="Produto anterior">
            <a-button
              class="qv-icon-btn"
              type="link"
              icon="left"
              size="small"
              :disabled="!canGoPrevious"
              @click="$emit('previous-product')"
            />
          </a-tooltip>

          <span class="qv-nav-counter">{{ currentIndex + 1 }}/{{ totalCount }}</span>

          <a-tooltip title="Próximo produto">
            <a-button
              class="qv-icon-btn"
              type="link"
              icon="right"
              size="small"
              :disabled="!canGoNext"
              @click="$emit('next-product')"
            />
          </a-tooltip>
        </template>

        <a-tooltip title="Expandir para janela">
          <a-button
            class="qv-icon-btn"
            type="link"
            icon="arrows-alt"
            size="small"
            @click="$emit('expand')"
          />
        </a-tooltip>

        <a-tooltip title="Fechar">
          <a-button
            class="qv-icon-btn"
            type="link"
            icon="close"
            size="small"
            @click="handleClose"
          />
        </a-tooltip>
      </div>

      <qv-header
        :product="product"
        :updated-at="updatedAt"
        :stores="stores"
        :selected-store-id="selectedStoreId"
        :store-locked="storeLocked"
        @change-store="handleStoreChange"
      />

      <div class="qv-body">
        <qv-preorder-actions
          :loading="loading"
          :quantity="requestedQuantity"
          :packaging="product && product.packing"
          :can-edit-packaging="canEditPackaging"
          :read-only="readOnly"
          :quantity-locked="quantityLocked"
          @update-quantity="$emit('update-quantity', $event)"
          @edit-packaging="$emit('edit-packaging')"
        />

        <div v-if="dataUnavailable" class="qv-no-data">
          <span class="material-icons-outlined">info</span>
          Sem dados de giro disponíveis — este produto não tem código interno cadastrado.
        </div>

        <template v-else>
          <qv-last-purchase :loading="loading" :last-purchase="lastPurchase" />
          <qv-stock-summary :loading="loading" :stock="stock" />
          <qv-last-sale :loading="loading" :last-sale="lastSale" />
          <qv-sales-analysis :loading="loading" :sales-analysis="salesAnalysis" />

          <qv-tabs
            :loading="loading"
            :purchases="purchases"
            :network-sales="networkSales"
            :network-total="networkTotal"
            :sales-points="salesPoints"
            :purchase-points="purchasePoints"
            :diagnostics-stores="diagnosticsStores"
          />
        </template>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import QvHeader from './product-quick-view/_qv-header.vue';
import QvPreorderActions from './product-quick-view/_qv-preorder-actions.vue';
import QvLastPurchase from './product-quick-view/_qv-last-purchase.vue';
import QvStockSummary from './product-quick-view/_qv-stock-summary.vue';
import QvLastSale from './product-quick-view/_qv-last-sale.vue';
import QvSalesAnalysis from './product-quick-view/_qv-sales-analysis.vue';
import QvTabs from './product-quick-view/_qv-tabs.vue';

export default {
  name: 'ProductQuickViewVertical',

  components: {
      QvHeader,
      QvPreorderActions,
      QvLastPurchase,
      QvStockSummary,
      QvLastSale,
      QvSalesAnalysis,
      QvTabs,
  },

  props: {
      updatedAt: {
          type: String,
          default: '',
      },

      diagnosticsStores: {
          type: Array,
          default: () => [],
      },

      loading: {
          type: Boolean,
          default: false,
      },

      visible: {
          type: Boolean,
          default: false,
      },

      product: {
          type: Object,
          default: null,
      },

      requestedQuantity: {
          type: [String, Number],
          default: 0,
      },

      lastPurchase: {
          type: Object,
          default: null,
      },

      stock: {
          type: Object,
          default: () => ({}),
      },

      lastSale: {
          type: Object,
          default: null,
      },

      salesAnalysis: {
          type: Array,
          default: () => [],
      },

      salesPoints: {
          type: Array,
          default: () => [],
      },

      purchasePoints: {
          type: Array,
          default: () => [],
      },

      purchases: {
          type: Array,
          default: () => [],
      },

      networkSales: {
          type: Array,
          default: () => [],
      },

      networkTotal: {
          type: Object,
          default: () => ({
              average: 0,
              total: 0,
          }),
      },

      stores: {
          type: Array,
          default: () => [],
      },

      hasNavigation: {
          type: Boolean,
          default: false,
      },

      canGoPrevious: {
          type: Boolean,
          default: false,
      },

      canGoNext: {
          type: Boolean,
          default: false,
      },

      currentIndex: {
          type: Number,
          default: 0,
      },

      totalCount: {
          type: Number,
          default: 0,
      },

      selectedStoreId: {
          type: [String, Number],
          default: null,
      },

      storeLocked: {
          type: Boolean,
          default: false,
      },

      readOnly: {
          type: Boolean,
          default: false,
      },

      quantityLocked: {
          type: Boolean,
          default: false,
      },

      dataUnavailable: {
          type: Boolean,
          default: false,
      },

  },

  computed: {
    canEditPackaging() {
        return !!this.product &&
            !this.product.is_generic &&
            !this.product.main_product_id;
    },
  },

  methods: {
    handleStoreChange(storeId) {
        this.$emit('change-store', storeId);
    },

    handleClose(){
        return this.$emit('close')
    }
  }
};
</script>

<style lang="scss" scoped>
@import './product-quick-view/_qv-shared.scss';

.qv-store-dropdown .ant-select-dropdown-menu-item {
    color: #222 !important;
    background: #fff !important;
}

.qv-store-dropdown .ant-select-dropdown-menu-item:hover {
    color: #222 !important;
}

.qv-store-dropdown .ant-select-dropdown-menu-item-selected {
    color: #222 !important;
}
.qv-drawer {
    z-index: 1050 !important;
    top: 64px;
}

.qv-drawer .ant-drawer {
    position: absolute !important;
    top: 64px !important;
    right: 0 !important;
    height: calc(100% - 64px) !important;
    z-index: 1050 !important;
}

.qv-drawer .ant-drawer-content-wrapper {
    top: 0 !important;
    height: 100% !important;
}

.qv-drawer .ant-drawer-content {
    height: 100%;
}
.qv-modal {
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  color: var(--text);
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
}

.qv-corner-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 6px;
}

.qv-icon-btn {
  flex-shrink: 0;
  color: var(--text-3);
  padding: 0 2px;
}

.qv-icon-btn:hover {
  color: var(--brand-deep);
}

.qv-nav-counter {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-3);
  white-space: nowrap;
}

.qv-modal ::v-deep .qv-head-top {
  padding-right: 76px;
}

.qv-modal.qv-nav-active ::v-deep .qv-head-top {
  padding-right: 136px;
}

.qv-body {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

::v-deep .product-quick-view-modal .ant-modal-content {
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
}

::v-deep .product-quick-view-modal .ant-modal-body {
  padding: 0;
}
</style>
